import { SAFE_SVG_CONTENT } from "./constants.js";

const svgFromString = (iconName) => {
    const svgText = SAFE_SVG_CONTENT[iconName];

    const doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
    return document.importNode(doc.documentElement, true);
};

export const CONTROL_DEFINITIONS = {
    playPause: ({ button, synth, utterance, state, text }) => {
        const icon = svgFromString("play");
        button.appendChild(icon);

        const updateIcon = () => {
            const next = state.isPlaying && !state.isPaused ? "pause" : "play";
            const newSvg = svgFromString(next);

            button.replaceChildren(newSvg);
        };

        utterance.addEventListener("end", () => {
            state.isPlaying = false;
            state.isPaused = false;
            updateIcon();
        });

        utterance.addEventListener("error", () => {
            state.isPlaying = false;
            state.isPaused = false;
            updateIcon();
        });

        updateIcon();

        button.addEventListener("click", () => {
            if (!text) return;

            if (!state.isPlaying && !state.isPaused) {
                synth.cancel();
                synth.speak(utterance);
                state.isPlaying = true;
                state.isPaused = false;
            } else if (state.isPlaying && !state.isPaused) {
                synth.pause();
                state.isPaused = true;
            } else {
                synth.resume();
                state.isPaused = false;
            }

            updateIcon();
        });
    },
};
